<template>
  <div style="width:100%;padding:10px;">
    <v-layout row wrap style="margin:0; align-items: center;">
      <v-flex xs12 sm4>
        <h1>{{ $t("general.dashboard") }}</h1>
      </v-flex>
      <v-flex xs12 sm8 style="text-align:right;">
        <v-btn @click="monthBack" text><i class="fal fa-chevron-double-left"></i></v-btn>
        <v-btn @click="dayBack" text><i class="fal fa-chevron-left"></i></v-btn>
        
        <span style="margin: 0 10px; font-weight: bold; font-size: 16px;">
          {{ formattedDate }}
          <i style="margin-left:5px;cursor:pointer;" @click="d_date_select = true;" class="fad fa-calendar-day"></i>
        </span>

        <v-btn @click="dayForward" :disabled="todayDate === cardDate" text><i class="fal fa-chevron-right"></i></v-btn>
        <v-btn @click="monthForward" :disabled="isCurrentMonth" text><i class="fal fa-chevron-double-right"></i></v-btn>
        <v-btn @click="toggleEditMode" text :color="editMode ? 'primary' : ''"><i class="fal fa-edit"></i></v-btn>
      </v-flex>
    </v-layout>
    
    <draggable v-model="layout" class="dashboard-masonry" handle=".drag-handle">
      <div class="masonry-item" v-for="card in layout" :key="card.id" v-show="card.visible || editMode">
        <div style="position: relative;">
          <div v-if="editMode" class="drag-handle" style="position: absolute; top: 10px; right: 10px; z-index: 10; cursor: grab; background: rgba(128,128,128,0.8); color: white; padding: 5px 10px; border-radius: 5px;">
            <i class="fas fa-arrows-alt"></i>
          </div>
          <div v-if="editMode" style="position: absolute; top: 10px; left: 10px; z-index: 10; background: rgba(255,255,255,0.8); border-radius: 5px; padding: 0 5px;">
            <v-switch v-model="card.visible" dense hide-details style="margin-top: 0; padding-top: 5px;"></v-switch>
          </div>
          
          <component :is="card.component" :date="cardDate" :style="{ opacity: card.visible ? 1 : 0.5, pointerEvents: editMode ? 'none' : 'auto' }"></component>
        </div>
      </div>
    </draggable>

    <v-dialog v-model="d_date_select" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t("today.select_date") }}</v-card-title>
        <v-card-text style="text-align:center;">
          <v-date-picker :allowed-dates="allowedDates" :first-day-of-week="1" :value="cardDate" @change="selectDate"></v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EntryCard from "../components/EntryCard";
import MoodCard from "../components/MoodCard";
import MapCard from "../components/timeline/MapCard";
import FitnessCard from "../components/fitness/FitnessCard";
import FitnessKPICard from "../components/fitness/FitnessKPICard";
import TracksCard from "../components/tracks/TracksCard";
import MediaCard from "../components/media/MediaCard";
import draggable from "vuedraggable";
import { storage } from "../schmucklicloud";

export default {
  components: {
    MoodCard,
    EntryCard,
    MapCard,
    FitnessCard,
    FitnessKPICard,
    TracksCard,
    MediaCard,
    draggable
  },
  data() {
    return {
      current_date: new Date(),
      d_date_select: false,
      editMode: false,
      layout: [
        { id: 'map', component: 'MapCard', visible: true },
        { id: 'fitness', component: 'FitnessCard', visible: true },
        { id: 'entry', component: 'EntryCard', visible: true },
        { id: 'mood', component: 'MoodCard', visible: true },
        { id: 'tracks', component: 'TracksCard', visible: false },
        { id: 'fitness_kpi', component: 'FitnessKPICard', visible: false },
        { id: 'media', component: 'MediaCard', visible: false }
      ]
    };
  },
  created() {
    var query_date = this.$route.params.date;
    if (query_date !== undefined) {
      let parts = query_date.split('-');
      this.current_date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    } else {
      this.updateUrl();
    }
  },
  mounted() {
    this.loadLayoutFromCloud();
  },
  watch: {
    $route() {
      var query_date = this.$route.params.date;
      if (query_date !== undefined) {
        let parts = query_date.split('-');
        let d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        if (d.getTime() !== this.current_date.getTime()) {
          this.current_date = d;
        }
      } else {
        let d = new Date();
        // Reset to today without time for comparison
        d.setHours(0,0,0,0);
        let cur = new Date(this.current_date);
        cur.setHours(0,0,0,0);
        if (d.getTime() !== cur.getTime()) {
          this.current_date = new Date();
          this.updateUrl();
        }
      }
    },
    cardDate() {
      this.updateUrl();
    }
  },
  computed: {
    cardDate() {
      return (
        this.current_date.getFullYear() +
        "-" +
        (this.current_date.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (this.current_date.getDate() + "").padStart(2, "0")
      );
    },
    formattedDate() {
      var months = [
        this.$t("general.month.january"),
        this.$t("general.month.february"),
        this.$t("general.month.march"),
        this.$t("general.month.april"),
        this.$t("general.month.may"),
        this.$t("general.month.june"),
        this.$t("general.month.july"),
        this.$t("general.month.august"),
        this.$t("general.month.september"),
        this.$t("general.month.october"),
        this.$t("general.month.november"),
        this.$t("general.month.december")
      ];

      var day_of_week = [
        this.$t("general.day_of_week.sunday"),
        this.$t("general.day_of_week.monday"),
        this.$t("general.day_of_week.tuesday"),
        this.$t("general.day_of_week.wednesday"),
        this.$t("general.day_of_week.thursday"),
        this.$t("general.day_of_week.friday"),
        this.$t("general.day_of_week.saturday")
      ];

      return (
        day_of_week[this.current_date.getDay()] + ", " +
        this.current_date.getDate() +
        ". " +
        months[this.current_date.getMonth()] +
        " " +
        this.current_date.getFullYear()
      );
    },
    todayDate() {
      var today = new Date();
      return (
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (today.getDate() + "").padStart(2, "0")
      );
    },
    isCurrentMonth() {
      var today = new Date();
      return this.current_date.getMonth() === today.getMonth() && this.current_date.getFullYear() === today.getFullYear();
    }
  },
  methods: {
    dayBack() {
      this.current_date.setDate(this.current_date.getDate() - 1);
      this.current_date = new Date(this.current_date);
    },
    dayForward() {
      this.current_date.setDate(this.current_date.getDate() + 1);
      this.current_date = new Date(this.current_date);
    },
    monthBack() {
      this.current_date.setMonth(this.current_date.getMonth() - 1);
      this.current_date = new Date(this.current_date);
    },
    monthForward() {
      this.current_date.setMonth(this.current_date.getMonth() + 1);
      if (this.current_date > new Date()) {
        this.current_date = new Date();
      }
      this.current_date = new Date(this.current_date);
    },
    selectDate(date) {
      this.current_date = new Date(date);
      this.d_date_select = false;
    },
    updateUrl() {
      if (this.$route.params.date !== this.cardDate) {
        this.$router.push("/dashboard/" + this.cardDate).catch(() => {});
      }
    },
    async toggleEditMode() {
      this.editMode = !this.editMode;
      if (!this.editMode) {
        this.saveLayoutToCloud();
      }
    },
    async saveLayoutToCloud() {
      for (let i = 0; i < this.layout.length; i++) {
        let card = this.layout[i];
        let payload = {
          card_id: card.id,
          position: i,
          visible: card.visible
        };
        if (card.row_id) {
          await storage.update("dashboard", card.row_id, payload);
        } else {
          let res = await storage.insert("dashboard", payload);
          if (res.isOK && res.data) {
            card.row_id = res.data.id;
          }
        }
      }
    },
    async loadLayoutFromCloud() {
      var response = await storage.getAll("dashboard");
      if (response.isOK && response.data && response.data.length > 0) {
        let dbLayout = response.data.sort((a,b) => parseInt(a.data.position) - parseInt(b.data.position));
        let newLayout = [];
        dbLayout.forEach(row => {
          let card = this.layout.find(c => c.id === row.data.card_id);
          if (card) {
            card.row_id = row.id;
            let v = row.data.visible;
            if (v !== undefined && v !== null && v !== '') {
              card.visible = (String(v).toLowerCase() === 'true' || String(v) === '1');
            }
            newLayout.push(card);
          }
        });
        
        // Add any local cards not in DB
        this.layout.forEach(card => {
          if (!newLayout.find(c => c.id === card.id)) {
            newLayout.push(card);
          }
        });
        
        this.layout = newLayout;
      }
    },
    allowedDates(val) {
      var date = new Date(val);
      return ((new Date()) - date) > 0;
    },
  }
};
</script>

<style scoped>
.dashboard-masonry {
  column-count: 2;
  column-gap: 15px;
  width: 100%;
  margin-top: 20px;
}
@media (max-width: 959px) { /* Vuetify sm and down */
  .dashboard-masonry {
    column-count: 1;
  }
}
.masonry-item {
  break-inside: avoid;
  margin-bottom: 15px;
  display: inline-block; /* Helps prevent weird clipping in some browsers */
  width: 100%;
}
</style>
